// ═══════════════════════════════════════════════════════════════
// UPLOAD ZONE
// ═══════════════════════════════════════════════════════════════
import { useState, useRef, useEffect } from "react";
import { ALL_ACCEPTED } from "./Utility";
import { Icons } from "./Icons";
// Add this useEffect for paste support




export function UploadZone({ onFilesAdded }) {
  const [dragging, setDragging] = useState(false);
  const [uploading, setUploading] = useState(false);
  const fileRef = useRef();
  const dragCounter = useRef(0);

  // Inside UploadZone, after dragCounter ref:
  useEffect(() => {
    const handlePaste = (e) => {
      const items = e.clipboardData?.items;
      if (!items) return;

      const files = [];
      for (const item of items) {
        if (item.kind === "file") {
          const file = item.getAsFile();
          if (file) files.push(file);
        }
      }
      if (files.length > 0) {
        e.preventDefault();
        handleFiles(files);
      }
    };

    window.addEventListener("paste", handlePaste);
    return () => window.removeEventListener("paste", handlePaste);
  }, []);

  const handleFiles = async (files) => {
    if (!files.length) return;
    setUploading(true);
    await onFilesAdded(Array.from(files));
    setUploading(false);
  };

  const onDragEnter = (e) => { e.preventDefault(); dragCounter.current++; setDragging(true); };
  const onDragLeave = (e) => { e.preventDefault(); dragCounter.current--; if (dragCounter.current === 0) setDragging(false); };
  const onDragOver = (e) => e.preventDefault();
  const onDrop = (e) => { e.preventDefault(); dragCounter.current = 0; setDragging(false); handleFiles(e.dataTransfer.files); };

  return (
    <div style={{ width: "100%", height: "100%", display: "flex", alignItems: "center", justifyContent: "center", padding: "32px" }}>
      <div
        onDragEnter={onDragEnter}
        onDragLeave={onDragLeave}
        onDragOver={onDragOver}
        onDrop={onDrop}
        onClick={() => fileRef.current?.click()}
        style={{
          width: "100%",
          maxWidth: 480,
          border: dragging ? "2px solid #7c3aed" : "2px dashed #d1d5db",
          borderRadius: "14px",
          padding: "48px 28px",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "12px",
          cursor: "pointer",
          background: dragging ? "rgba(124,58,237,0.03)" : "#fafafa",
          transition: "all 0.2s",
        }}
      >
        <div style={{ color: dragging ? "#7c3aed" : "#9ca3af", transition: "color 0.2s, transform 0.2s", transform: dragging ? "translateY(-3px)" : "none" }}>
          <Icons.UploadCloud />
        </div>
        {uploading ? (
          <span style={{ color: "#7c3aed", fontSize: "14px", fontWeight: 500 }}>Processing files…</span>
        ) : (
          <>
            <span style={{ color: "#1f2937", fontSize: "14px", fontWeight: 600 }}>{dragging ? "Drop files here" : "Click to upload or drag & drop or Simply Paste"}</span>
            <span style={{ color: "#9ca3af", fontSize: "12px" }}>Images, Videos, or PDFs</span>
          </>
        )}
        <input ref={fileRef} type="file" accept={ALL_ACCEPTED} multiple style={{ display: "none" }} onChange={(e) => { handleFiles(e.target.files); e.target.value = ""; }} />
      </div>
    </div>
  );
}